module.exports = __webpack_public_path__ + "static/media/person-ready-watching-svgrepo-com.986cf4ea.svg";